import React, { useEffect, useState } from 'react'

import { ComboFolderSelectorProps } from './ComboFolderSelector.types'

import { getHost } from '../hooks'
import { FileInput } from '../atoms'

import { SelectCloudArtifacts } from '../SelectCloudArtifacts/SelectCloudArtifacts'

import { CloudPlus, FileEarmarkArrowUp, Laptop } from 'react-bootstrap-icons'

import ButtonGroup from '../atoms/ButtonGroup/ButtonGroup'
import SelectLocalArtifactNative from '../SelectLocalArtifactNative/SelectLocalArtifactNative'
import { FileMeta } from '@pollination-solutions/pollination-sdk'
import { LocalArtifactDataCollection } from '../SelectLocalArtifactNative/SelectLocalArtifactNative.types'

export const ComboFolderSelector: React.FC<ComboFolderSelectorProps> = ({ 
  projectOwner,
  projectName,
  value,
  hidden = false,
  disabled = false,
  defaultOption = undefined,
  onChange,
  client,
  inputProps
}) => {
  const host = getHost()

  const [option, setOption] = useState(() => {    
    if(defaultOption) return

    if (host !== 'web') {
      return 'get_local'
    } else {
      return 'upload'
    }
  })

  useEffect(() => {
    if(!defaultOption) return

    if (host !== 'web' && defaultOption === 'upload') {
      setOption('get_local')
      return
    }

    if (host === 'web' && defaultOption === 'get_local') {
      setOption('upload')
      return
    }

    setOption(defaultOption)
  }, [defaultOption])

  // reset onChange if option
  useEffect(() => {
    !hidden && onChange()
  }, [option])

  return (
    <div data-testid="ComboFileSelector"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8
      }}
    >   
      {!hidden &&
        <ButtonGroup>
          {(host === 'web' || option === 'upload') &&  
            <button
              type='button'
              disabled={disabled}
              onClick={() => setOption('upload')}
              style={{
                display: 'flex',
                boxShadow: !disabled && option === 'upload' ? 
                  'inset 0px 0px 9px 4px #096dd9' : undefined
              }}
            >
              <FileEarmarkArrowUp/>
            Upload
            </button>
          }
          <button
            type='button'
            disabled={disabled || host !== 'web'} // TODO: remove this condition when hook is ready
            onClick={() => setOption('get_cloud')}
            style={{
              display: 'flex',
              boxShadow: !disabled && option === 'get_cloud' ? 
                'inset 0px 0px 9px 4px #096dd9' : undefined,
              background: host !== 'web' ? 'gray' : undefined // TODO: remove this condition when hook is ready
            }}
          >
            <CloudPlus/>
          {/* TODO: remove this condition when hook is ready */}
          {host === 'web' ? 'Cloud' : 'WIP'}
          </button>
          {(host !== 'web' || option === 'get_local') &&
            <button
              type='button'
              disabled={disabled}
              onClick={() => setOption('get_local')}
              style={{
                display: 'flex',
                boxShadow: !disabled && option === 'get_local' ? 
                  'inset 0px 0px 9px 4px #096dd9' : undefined
              }}
            >
              <Laptop/>
              Local
            </button>
          }
        </ButtonGroup>}
      {!hidden && (() => {
        switch(option){
          case 'get_cloud':
            return (
              <SelectCloudArtifacts 
                projectOwner={projectOwner}   
                projectName={projectName} 
                hidden={hidden}
                value={value as FileMeta}
                onChange={onChange} 
                fileNameMatch={'.99999'}
                enableFolderSelection={true}
                client={client}
            />
            )
          case 'get_local':
            return (
              <SelectLocalArtifactNative 
                value={value as LocalArtifactDataCollection}
                onChange={onChange}
                mode='recursive'
              />
            )
          default:
            return (
              <FileInput
                mode='folder' 
                onChange={onChange} 
                inputProps={inputProps} 
              />
            )
        }
      })()}
    </div>
  )
}

export default ComboFolderSelector